<script setup lang="ts">
  const props = defineProps<{
    label?: string;
  }>();
  
  useZohoDeskAsap();
  const errorModal = useErrorModal();
</script>
<template>
  <main class="">
    <div class="h-[62px] w-full flex justify-between">
      <SystemLogoPrimary />
      <CommonButton
        :label="props.label"
        @onClick?=""
        rounded
        color="secondary"
      />
    </div>
    <slot />
  </main>
  <CommonErrorModal
    v-model:is-open="errorModal.isOpen.value"
    :title="errorModal.title.value"
    :message="errorModal.message.value"
    @dismiss="errorModal.dismiss()"
  />
</template>
<style scoped></style>
